/**
 * Swiper Gallery Carousel for legacy apartments
 */
document.addEventListener('DOMContentLoaded', function () {
	// Gallery Grid - Grid
	var carouselBlock = new Swiper('.galleryGrid.style-grid .galleryCarouselSwiper', {
		slidesPerView: 2,
		direction: 'horizontal',
		slidesPerColumnFill: 'column',
		slidesPerGroup: 2,
		preloadImages: false,
		threshold: 3, // Fixes issues with links inside of Swiper
		mousewheel: {
			// Horizontal scrolling with mouse
			enabled: true,
			releaseOnEdges: true,
			forceToAxis: true, // Avoid hijacking normal scroll
		},
		scrollbar: {
			el: '.swiper-scrollbar.gallery',
			draggable: true,
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
	});

	// Gallery Grid - Wide
	var carouselBlockWide = new Swiper('.galleryGrid.style-wide .galleryCarouselSwiper', {
		// Optional parameters
		slidesPerView: 'auto',
		direction: 'horizontal',
		slidesPerGroup: 2,
		preloadImages: false,
		threshold: 3, // Fixes issues with links inside of Swiper
		scrollbar: {
			el: '.swiper-scrollbar.gallery',
			draggable: true,
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
	});

	// Swiper Controls
	var swiperInitTriggers = document.querySelectorAll('[data-swiper]');

	swiperInitTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', swiperInit);
	});

	function swiperInit(event) {
		var swiperToInit = this.getAttribute('data-swiper'); // We may want to change this in the future
		var swiperToInitClass = '.' + swiperToInit;
		var slideToOpen = this.getAttribute('data-slide');
		console.log('galleryCarousel.swiperInit', event, swiperToInit, slideToOpen);
		var galleryCarouselModalSwiper = new Swiper(swiperToInitClass, {
			// Optional parameters
			slidesPerView: 'auto',
			initialSlide: slideToOpen,
			direction: 'horizontal',
			loop: false, // true may cause a11y issues
			init: true,
			preloadImages: true,
			lazy: true,
			loadPrevNext: true,
			loadOnTransitionStart: true,
			autoHeight: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev',
			},
			hashNavigation: true,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			on: {
				afterInit: function (swiper) {
					if (slideToOpen == 0) {
						swiper.update();
						console.log('galleryCarousel.swiperInit.afterInit', this, slideToOpen);
						swiper.lazy.loadInSlide(slideToOpen);
						swiper.slideTo(0);
					}
					swiper.on('slideChange', function (swiper) {
						console.log('slide changed', swiper.el);
						const iframes = swiper.el.querySelectorAll('iframe');
						for (const iframe of iframes) {
							let videoSrc = iframe.getAttribute('src');
							console.log('closeDialog.videoSrc', videoSrc);
							if (videoSrc !== '' && videoSrc !== null) {
								const url = new URL(videoSrc);
								console.log(
									'closeDialog.videoSrc',
									videoSrc,
									url,
									url.searchParams.toString()
								);
								url.searchParams.delete('autoplay');
								url.searchParams.set('autopause', 0);
								console.log('closeDialog.videoSrc', videoSrc, url.href);
								iframe.setAttribute('src', '');
								iframe.setAttribute('src', url.href);
							}
						}
					});
				},
			},
		});
	}
});
